<template>
  <div>
    <page-table :data-api="this.api.coach.member" key-field="uid" edit-path="/main/member/edit" :params="params" :deletable="false">
      <el-table-column prop="uid" label="编码" width="300">
      </el-table-column>
      <el-table-column prop="name" label="姓名">
      </el-table-column>
      <el-table-column prop="sex" label="性别">
      </el-table-column>
      <el-table-column prop="mobile" label="手机">
      </el-table-column>
      <el-table-column prop="comment" label="备注">
      </el-table-column>
    </page-table>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  created: function () {
  },
  methods: {
  },
  computed: {
    params: function () {
      return { coachId: this.$route.params.id }
    }
  }
}
</script>



// WEBPACK FOOTER //
// member.vue?655fd69e